import React from 'react';
import styled from 'styled-components';
import { INPUT_TYPES } from 'utils/CommonConstants';
import { RESOLUTIONS as BREAKPOINTS } from 'services/config';
import TextInput from 'sub_components/Common/BloxTextInput';

const BodyStyle = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	.blox-text-input {
		width: 300px;
		margin-bottom: 20px;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.blox-text-input {
			width: 450px;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.blox-text-input {
			width: 780px;
		}
	}
`;

const MAX_TEXT_AREA_HEIGHT = {
	[BREAKPOINTS.LOW]: 104,
	[BREAKPOINTS.MED]: 180,
	[BREAKPOINTS.HIGH]: 200,
};

export const CompanyModalBody = ({ breakpoint, setChange, newChange, oldChange }) => {
	return (
		<BodyStyle className='company-modal'>
			<TextInput
				placeholder='What would like to change ?'
				type={INPUT_TYPES.TEXTAREA}
				label='Previous Details'
				name='oldChange'
				value={oldChange}
				onChange={event => setChange(event)}
				characterMinLength={10}
				showCharacterCount={true}
				active={true}
				setDefaultValueAsPlaceholder
				minMessage={true}
				maxTextAreaHeight={MAX_TEXT_AREA_HEIGHT[breakpoint]}
				breakpoint={breakpoint}
				cypressId='issue-description-textarea'
				id='issue-description-textarea'
			/>
			<TextInput
				placeholder='Please be as descriptive as possible.'
				type={INPUT_TYPES.TEXTAREA}
				label='New Details'
				name='newChange'
				value={newChange}
				onChange={event => setChange(event)}
				characterMinLength={10}
				showCharacterCount={true}
				active={true}
				setDefaultValueAsPlaceholder
				minMessage={true}
				maxTextAreaHeight={MAX_TEXT_AREA_HEIGHT[breakpoint]}
				breakpoint={breakpoint}
				cypressId='issue-description-textarea'
				id='issue-description-textarea'
			/>
		</BodyStyle>
	);
};
